module.exports = __webpack_public_path__ + "img/szamlazzhu-icon.f462fc11.svg";